import './_multi-select.dark-mode.scss';
import './_multi-select.scss';
import React, { useState, useEffect, useRef } from 'react';
import { Dropdown, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';

import SearchMenu from './components/Menu';
import SearchToggle from './components/Toggle';

import { isTouchDevice } from '../../../utils/helper';

const SearchFilter = ({ options, toggleBtnTitle, className, label, selectedOptions, optionsTitle, onSubmit }) => {
  const inputRef = useRef(null);
  const listRef = useRef(null);

  const [values, setValues] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [open, setOpen] = useState();

  const onToggleClose = () => setOpen(!open);

  const onSelectValue = (key, title, isTitle) => {
    switch (isTitle) {
    case true:
      const valuesByTitle = filteredOptions
        ?.filter((item) => Number(item.category_id) === Number(key) && !item.isCategory)
        ?.filter((item) => !item.isDisabled);

      if (values.includes(title)) {
        const ratesForCategory = valuesByTitle.filter((item) => !item.isDisabled).map((rate) => rate.id);
        setValues([...new Set(values.filter((item) => item !== title).filter((item) => !ratesForCategory.includes(item)))]);
      } else {
        setValues([...new Set([...values, title, ...valuesByTitle.map((item) => item.id)])]);
      }

      break;

    default:
      const fullRateByCategory = filteredOptions
        ?.filter((item) => Number(item.category_id) === Number(title) && !item.isCategory)
        ?.map((item) => item.id);

      if (values.includes(key)) {
        const newValues = values.filter((item) => item !== key);
        if (!fullRateByCategory.every((v) => newValues.includes(v))) {
          return setValues([...new Set(newValues.filter((item) => item !== isTitle))]);
        }
        setValues(newValues);
      } else {
        const newValues = [...values, key];
        if (fullRateByCategory.every((v) => newValues.includes(v))) {
          return setValues([...new Set([...newValues, isTitle])]);
        }
        setValues(newValues);
      }

      break;
    }
  };

  const handleFocus = () => {
    if (isTouchDevice() === false) {
      return inputRef?.current?.focus();
    }
  };

  useEffect(() => {
    if (open) {
      return inputRef?.current?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const onSubmitOptions = () => {
    if (values.length > 0) {
      const flatOptions = options.map((item) => item.services).flat();
      const filteredValues = values.filter(Number);
      const findedOptions = flatOptions.filter((opt) => filteredValues.includes(opt.id));

      onSubmit && onSubmit(findedOptions);
    }

    setValues([]);
  };

  return (
    <>
      {label && <ControlLabel>{label}</ControlLabel>}
      <Dropdown
        onToggle={onToggleClose}
        id="dropdown"
        open={open}
        rootCloseEvent="click"
        onFocus={() => handleFocus()}
        className={`${className || ''} dropdown-multi`}
      >
        <SearchToggle bsRole="toggle">
          {values.filter(Number).length ? (
            <span>
              <span className="options-count">{values.filter(Number).length}</span>
              {' '}
              <span>{optionsTitle}</span>
              {' '}
              <span>selected</span>
            </span>
          ) : (
            <span>{toggleBtnTitle}</span>
          )}
        </SearchToggle>

        <SearchMenu
          bsRole="menu"
          inputRef={inputRef}
          listRef={listRef}
          setValues={setValues}
          filteredOptions={filteredOptions}
          values={values}
          options={options}
          selectedOptions={selectedOptions}
          handleFocus={handleFocus}
          onToggleClose={onToggleClose}
          onSubmitOptions={onSubmitOptions}
          onSelectValue={onSelectValue}
          setFilteredOptions={setFilteredOptions}
        />
      </Dropdown>
    </>
  );
};

SearchFilter.propTypes = {
  options: PropTypes.array,
  toggleBtnTitle: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  selectedOptions: PropTypes.array,
  optionsTitle: PropTypes.string,
  onSubmit: PropTypes.func,
};

SearchFilter.defaultProps = {
  options: [],
  toggleBtnTitle: 'Options',
};

export default SearchFilter;
